import { PRODUCTS_FETCHED, LOG_OUT } from "../types";

const INITIAL_STATE = [];

export default function products(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case PRODUCTS_FETCHED:
      return action.data;
    case LOG_OUT:
      return INITIAL_STATE;
    default:
      return state;
  }
}
